module.exports = __webpack_public_path__ + "static/media/vb.3c5942e4.png";